import { getTHERMSImageThumbnailUrl } from "../../utils/get-therms-image-thumbnail-url.js";
import { FileUploadCard } from "./index.js";
import { getFileMetadataFromUrl } from "../../utils/get-file-metadata-from-url.js";
import { useCallback, useEffect, useRef, useState } from "react";
import { Loading } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
// src/modules/Files/components/FileUploadCard/ExistingUploadCard.tsx
var ExistingUploadCard = ({ isPrimaryImage, onClickPreview, onRemove, onSetPrimaryImage, url }) => {
	const [file, setFile] = useState();
	const [loading, setLoading] = useState(false);
	const local = useRef({});
	const loadMetadata = useCallback((url) => {
		setLoading(true);
		const { abortPromise, promise } = getFileMetadataFromUrl(url);
		local.current.abortPromise = abortPromise;
		promise.then((metadata) => {
			if (metadata) {
				const imagePreviewUrl = metadata.type.includes("image") ? getTHERMSImageThumbnailUrl(url) : void 0;
				setFile({
					accessUrl: url,
					file: new File([], metadata.name, { type: metadata.type }),
					id: url,
					imagePreviewUrl,
					name: metadata.name,
					size: +metadata.size,
					status: "uploaded",
					type: metadata.type
				});
			} else throw new Error("getFileMetadataFromUrl() failed, need to retry");
		}).catch((err) => {
			console.warn("<ExistingUploadCard /> getFileMetadataFromUrl() err, retrying", url, err);
			setFile({
				accessUrl: url,
				file: new File([], "File Not Found", { type: "error" }),
				id: url,
				imagePreviewUrl: url,
				name: "File Not Found",
				size: 0,
				status: "uploaded",
				type: "error"
			});
			local.current.timeout = setTimeout(() => {
				loadMetadata(url);
			}, 2500);
		});
		setLoading(false);
	}, []);
	useEffect(() => {
		if (url) loadMetadata(url);
		return () => {
			local.current?.abortPromise?.();
			clearTimeout(local.current.timeout);
		};
	}, [url]);
	if (file) return /* @__PURE__ */ jsx(FileUploadCard, {
		file,
		isPrimaryImage,
		onCancel: () => onRemove?.(url),
		onClickPreview,
		onSetPrimaryImage
	});
	return /* @__PURE__ */ jsx("div", { children: loading && /* @__PURE__ */ jsx(Loading, {
		className: "w-20",
		size: "sm"
	}) });
};
export { ExistingUploadCard };

//# sourceMappingURL=ExistingUploadCard.js.map